const EVENT_READY = 'signlift:signature:ready';
const EVENT_SUCCESS = 'signlift:signature:success';
const EVENT_ERROR = 'signlift:signature:error';

const KNOWN_EVENTS = new Set([EVENT_READY, EVENT_SUCCESS, EVENT_ERROR]);

function originOf(signingUrl) {
  try {
    return new URL(signingUrl).origin;
  } catch {
    return null;
  }
}

export function embedSignature(container, signingUrl) {
  if (!container || !signingUrl) return null;

  const iframe = document.createElement('iframe');
  iframe.src = signingUrl;
  iframe.className = 'signature-iframe';
  iframe.allow = 'clipboard-write';
  iframe.sandbox = 'allow-scripts allow-same-origin allow-forms';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.title = 'Signature';
  container.replaceChildren(iframe);

  return iframe;
}

export function onSignliftEvent(callback, signingUrl, iframe = null) {
  const expectedOrigin = originOf(signingUrl);
  if (!expectedOrigin) return () => {};

  const handler = (event) => {
    if (event.origin !== expectedOrigin) return;
    if (iframe && event.source !== iframe.contentWindow) return;

    const type = event.data?.type;
    if (!KNOWN_EVENTS.has(type)) return;

    callback({ type });
  };

  window.addEventListener('message', handler);

  return () => window.removeEventListener('message', handler);
}

export function finalizeSignature(url) {
  if (!url) return Promise.resolve();

  return fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  }).catch((error) => {
    console.warn('[Signlift] finalize request failed', error);
  });
}

export const SIGNLIFT_EVENTS = {
  READY: EVENT_READY,
  SUCCESS: EVENT_SUCCESS,
  ERROR: EVENT_ERROR,
};
